import { NavBarContainer, NavTab } from './style'

const TABS = [
  { label: 'Informações', to: '/modal' },
  { label: 'Histórico', to: '/modal/historico' },
  { label: 'Pagamento', to: '/modal/pagamento' },
  { label: 'Pedidos', to: '/modal/pedidos' },
  { label: 'Rastreio', to: '/modal/rastreio' },
  { label: 'Campos', to: '/modal/campos' },
]

export function NavBar() {
  return (
    <NavBarContainer>
      {TABS.map((tab) => (
        <NavTab key={tab.to} to={tab.to} end={tab.to === '/modal'}>
          {tab.label}
        </NavTab>
      ))}
    </NavBarContainer>
  )
}
